// I *think* this is all the parameters - not fully conclusive
export interface Attribute {
  id: string
  displayName: string
  type: 'string' | 'boolean' | 'number' | 'complex'
  scimAttributeName: string
  urn: string

  scimSchema?: string
  scimParentAttributeName?: string
  description?: string
  custom?: boolean
  targetable?: boolean
  required?: boolean
  editable?: boolean
  visible?: boolean
  multiValued?: boolean
}

export enum SEARCH_TYPES {
  search,
  aggregate,
  collectionEmailsSearch,
  collectionEmployeeNumbersSearch
}

// This is a concept that only exists on the frontend
export interface DropdownAttribute {
  id: string
  displayName: string
  placeholder?: string

  attribute?: Attribute

  type: SEARCH_TYPES

  // Grab bag of additional fields (may only be used by tests)
  [key: string]: any
}

export interface SearchResult {
  id: string // This is required for the AutoComplete component
  count: number
  resourceType: string //'Group' | 'User'
  term: string | null
  termId: string | null
  subtitle: string | null
  displayValue?: string
  displayName?: string
  name?: string
  type: 'group' | 'individual' | 'variable' | 'user'
  attributeId?: string
  urn?: string
}

export interface Variable {
  name: string
  stepName: string | undefined
  stepLabel: string
  displayName: string
  type: string
  isNested?: boolean
  icon: string | JSX.Element
}

export interface SearchHandler {
  search: (searchTerm: string) => Promise<SearchResult[]>
  getAttribute: (scimAttributeName: string) => Attribute
  getValue?: (searchResult: SearchResult) => { value: string; displayValue: string; subtitle?: string | undefined }
}
